import * as Common from '@tfo/common'
import Axios from 'axios'
import RootStore from './RootStore'
import { observable, action } from 'mobx'

import { validate, validateAll } from '../utils/validation'
import $http from '../utils/$http'
interface ErrorState {
	email: boolean
}

const validators = {
	email: ['empty', 'email'],
}

export class ForgotCreatePasswordController {
	@observable public email: string = ''
	@observable public rootStore: RootStore
	@observable public loading: boolean = false
	@observable public errorModel: Common.models.ErrorModel<ErrorState>
	@observable public showForgotCreatePasswordComplete: boolean = false

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
		this.errorModel = new Common.models.ErrorModel({ email: false })
	}

	@action public onChange(key: string, value: string) {
		this[key] = value
	}

	@action public async onBlur(
		key: string,
		value: string | boolean,
	): Promise<void> {
		await this.errorModel.onChange(key, !validate(value, validators[key]))
	}

	@action public onKeyDown(keyCode: number) {
		if (keyCode === 13) {
			this.onForgotCreatePassword()
		}
	}

	@action public async onForgotCreatePassword() {
		this.loading = true
		const valid = validateAll({ email: this.email }, validators)

		if (valid.length > 0) {
			valid.forEach(async element => {
				await this.errorModel.onChange(element.key, !element.valid)
			})
			this.loading = false
		} else {
			const credentials = {
				email: this.email,
				userType: 'Company',
			}

			return await $http.post<any>(`/user/password/reset/send`, credentials)
				.then(() => {
					this.showForgotCreatePasswordComplete = true
					this.loading = false
				})
				.catch(error => {
					if (error.response.status === 404) {
						Axios.post(error.response.data)
					}
					this.showForgotCreatePasswordComplete = true
					this.loading = false
				})
		}
	}
}
